import { createRouter, createWebHistory } from "vue-router";
import Map from "./views/Map.vue";
import Sites from "./views/Sites.vue";

export default createRouter({
	history: createWebHistory(),
	routes: [{
		name: "map",
		path: "/app",
		component: Map
	}, {
		name: "sites",
		path: "/app/sites",
		component: Sites
	}]
});
